import { createApp, h } from 'vue';
import EventSearchApp from '../components/event_search/event_search_app.vue';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('event_search_app');
  const resultsContainer = document.getElementById('event_results_container');

  if (element && resultsContainer) {
    const dataset = element.dataset;

    const app = createApp({
      render: () => h(EventSearchApp, {
        apiEndpoint: dataset.apiEndpoint,
        initialEvents: JSON.parse(dataset.initialEvents),
        initialPagination: JSON.parse(dataset.initialPagination),
        initialLocation: dataset.initialLocation,
        formData: JSON.parse(dataset.formData),
        useMetric: dataset.useMetric === 'true',
        copy: JSON.parse(dataset.copy),
        resultsContainerId: 'event_results_container'
      })
    });
    app.mount(element);

    // The page's tour (packs/event_search_tour.js) points inside the filters
    // and results, so it waits for this.
    document.dispatchEvent(new CustomEvent('event-search:mounted'));
  }
});
